import React from 'react';
import { connect } from 'react-redux';
import UserSummary from './userSummary';
import OfferCards from './offerCards';
import IncentiveList from './incentiveList';
import StatusDetails from './statusDetails';
import { NarrowContainer } from 'scy/layouts';
import Card from 'scy/Card';
import { pageContainer } from 'scy/utils.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';

class LoyaltyPage extends React.Component {
  render() {
    const {
      currentPoints,
      currentStatus,
      programDescription,
      programTitle,
      statusTiers,
      nextStatus,
      completedActions,
      uncompletedActions,
      user,
      loading
    } = this.props;

    return (
      <NarrowContainer className={`${pageContainer} ${margin.tablet_lg}`}>
        <Card
          borderClass={null}
          paddingClass={`${padding.top_sm} ${padding.bottom_sm}`}
        >
          <div className={margin.md}>
            <UserSummary
              currentPoints={currentPoints}
              currentStatus={currentStatus}
              nextStatus={nextStatus}
              loading={loading}
              user={user}
            />
          </div>

          <OfferCards offers={uncompletedActions.slice(0, 2)} />

          <IncentiveList
            completed={completedActions}
            uncompleted={uncompletedActions}
          />

          {!loading && (
            <StatusDetails
              title={(currentStatus && currentStatus.title) || programTitle}
              description={
                (currentStatus && currentStatus.description) ||
                programDescription
              }
              currentPoints={currentPoints}
              statusTiers={statusTiers}
              nextStatus={nextStatus}
            />
          )}
        </Card>
      </NarrowContainer>
    );
  }
}

export default connect(
  state => ({
    ...state.loyalty,
    user: state.login.user
  }),
  {}
)(LoyaltyPage);
